import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareDotedBehindSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-doted-behind-square, copy, layers, pages"><path d="M8.75 8V8.75M8.75 5V2.75H11M19 2.75H21.25V5M14 2.75H16M21.25 8V10M21.25 13V15.25H19M16 15.25H15.25M15.25 8.75H2.75V21.25H15.25V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareDotedBehindSquare;
